var map = {
	"./br/drag-to-answer-white.png": "8330",
	"./de/drag-to-answer-white.png": "0c04",
	"./el/drag-to-answer-white.png": "e445",
	"./en/drag-to-answer-white.png": "8aac",
	"./es/drag-to-answer-white.png": "a806",
	"./it/drag-to-answer-white.png": "c05c",
	"./ko/drag-to-answer-white.png": "2c25",
	"./ru/drag-to-answer-white.png": "2214",
	"./sl/drag-to-answer-white.png": "7739",
	"./tr/drag-to-answer-white.png": "dd4e",
	"./us/drag-to-answer-white.png": "b144"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95da";